export default "__VITE_ASSET__z$DFtyH0__"